export default "__VITE_ASSET__c8705f01__"